import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

// Link-styled back nav that sits below the panel's primary action,
// hugging the start edge (left in LTR; the arrow flips via
// rtl:-scale-x-100 in RTL). inline-flex so the button only takes the
// width of its content — the previous block-level submit button
// pushes us to a new line, and we naturally land at the inline-start
// edge without explicit alignment classes.
//
// Used on every step except Start (which has no back state) and
// Upsell (whose Decline path is a sibling button, not a back nav).
const BackLink = ({ i18n, onClick, disabled }) =>
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="btn-link inline-flex items-center gap-2 font-semibold underline underline-offset-2 disabled:opacity-50"
  >
    <FontAwesomeIcon icon={faArrowLeft} className="rtl:-scale-x-100" />
    {i18n.t('back')}
  </button>

export default BackLink
